import request from '@/common/js/request'

/**
 * 视频推荐列表
 */
export const recommendVideosGet = (option = {}) => {
    return request({
        url: '/apis/recommend/videos',
        method: 'get',
        ...option
    })
}
